import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

export default styled(Icon)`
  align-self: center;
  justify-self: center;
  font-size: 2rem;
  display: block;
  text-align: center;
  margin-bottom: 1rem;
`;
